import React from 'react';
import { MenuItem, Select } from '@mui/material';

export const SettingsNestedOperatorSelect = ({
  setSettingsNestedOperator,
  settingsNestedOperator,
}) => {
  const choices = [
    { id: 'ten99', name: '1099' },
    { id: 'w2.travel', name: 'W2 Travel' },
    { id: 'w2.local', name: 'W2 Local' },
  ];

  return (
    <Select
      id="settings-nested-operator-select"
      label="Plan"
      value={settingsNestedOperator}
      onChange={(e) => setSettingsNestedOperator(e.target.value)}
      variant="filled"
      sx={{ marginBottom: 2, width: 250 }}
    >
      {choices.map((choice) => (
        <MenuItem key={choice.id} value={choice.id}>
          {choice.name}
        </MenuItem>
      ))}
    </Select>
  );
};
